<template>
  <div class='severity-count' :style="style">
    {{getCount}}
  </div>
</template>

<script>
import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'ComplianceSeverity',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getCount() {
      return this.value.count || 0;
    },
    colorsForLevels() {
      const {severity} = this.value;
      if (severity === this.$t('critical')) {
        return { color: '#DF399F' };
      }
      if (severity === this.$t('high')) {
        return { color: '#FF7F00' };
      }
      if (severity === this.$t('medium')) {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    style() {
      return {
        backgroundColor: hexToRgba(this.colorsForLevels.color, 0.1),
        ...this.colorsForLevels,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.severity-count {
  color: var(--text-secondary);
  background-color: rgba(169, 182, 195, 0.1);
  border-radius: $radius-md;
  text-transform: capitalize;
  align-items: center;
  display: flex;
  font-family: $font-family-semibold;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: rem(17);
  justify-content: center;
  padding: rem(2) rem(5);
}
</style>
